<template>
  <div style="padding: 10px">

    <h1 class="center"> Register my account </h1>
    <el-form :model="model" :rules="rules" ref="signUpForm">
      <el-form-item label="Phone Number">
        <el-input type="number" v-model="model.username">
           <template slot="prepend">+234</template>
        </el-input>
      </el-form-item>

      <el-form-item label="Email Address">
        <el-input type="email" v-model="model.email"/>
      </el-form-item>

      <el-form-item label="Password">
        <el-input type="password" v-model="model.password"/>
      </el-form-item>

      <el-form-item label="Confirm Password">
        <el-input type="password" v-model="model.confirm_password"/>
      </el-form-item>
    </el-form>
    <el-button :loading="loading" @click="handleOnRegister"  style="width: 100%;" type="warning">Create account</el-button>
  </div>
</template>

<script>
import { register } from '@/services/auth'
export default {
  name: 'SignUp',
  data () {
    return {
      loading: false,
      model: {
        username: '',
        email: '',
        password: '',
        confirm_password: ''
      },
      rules: {
        email: [
          { type: 'email', required: true, message: 'Please provide email', trigger: 'blur' }
        ],
        username: [
          { required: true, message: 'Please provide email', trigger: 'blur' }
        ]

      }
    }
  },

  methods: {
    validate () {
      if (this.model.username) {

      }
    },
    handleOnRegister () {
      register(this.model)
        .then((res) => {
          // TODO use setTimeout before redirecting
          setTimeout(this.$router.push({ name: 'Auth' }), 1000)
        })
        .catch(err => {
          this.$message.error({
            message: err.response.data
          })
        })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/auth/SignUp.vue